import React, { useState } from 'react';
import classNames from 'classnames';

import { ensureListing } from '../../../util/data';

import SearchMapListingCard from '../SearchMapListingCard/SearchMapListingCard';

import css from './SearchMapInfoCard.module.css';

/**
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that extends the default class for the root element
 * @param {Array<propTypes.listing>} props.listings - The listings
 * @param {Function} props.onListingInfoCardClicked - The function to handle the listing info card click
 * @param {Function} props.createURLToListing - The function to create the URL to the listing
 * @param {Object} props.config - The configuration
 * @returns {JSX.Element}
 */
const SearchMapInfoCard = props => {
  const [currentListingIndex, setCurrentListingIndex] = useState(0);
  const {
    className,
    rootClassName,
    listings,
    onListingInfoCardClicked,
    createURLToListing,
    config,
    currentUser,
  } = props;

  const currentListing = ensureListing(listings[currentListingIndex]);
  const hasCarousel = listings.length > 1;
  const listingURL =
    typeof createURLToListing === 'function' ? createURLToListing(currentListing) : '#';

  const classes = classNames(rootClassName || css.root, className);
  const caretClass = classNames(css.caret, { [css.caretWithCarousel]: hasCarousel });

  return (
    <div
      className={classes}
      onClick={e => {
        e.stopPropagation();
      }}
      onDoubleClick={e => {
        e.stopPropagation();
      }}
    >
      <div className={css.caretShadow} />
      <div
        className={classNames(css.card, css.borderRadiusInheritTop, {
          [css.borderRadiusInheritBottom]: !hasCarousel,
        })}
      >
        <SearchMapListingCard
          className={css.searchMapListingCard}
          listing={currentListing}
          clickHandler={onListingInfoCardClicked}
          urlToListing={listingURL}
          isInCarousel={hasCarousel}
          config={config}
          currentUser={currentUser}
        />
      </div>
      {hasCarousel ? (
        <div className={classNames(css.paginationInfo, css.borderRadiusInheritBottom)}>
          <button
            className={css.paginationPrev}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setCurrentListingIndex(
                prevListingIndex => (prevListingIndex + listings.length - 1) % listings.length
              );
            }}
          />
          <div className={css.paginationPage}>
            {`${currentListingIndex + 1}/${listings.length}`}
          </div>
          <button
            className={css.paginationNext}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              setCurrentListingIndex(
                prevListingIndex => (prevListingIndex + listings.length + 1) % listings.length
              );
            }}
          />
        </div>
      ) : null}
      <div className={caretClass} />
    </div>
  );
};

export default SearchMapInfoCard;
